import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function PageHeader({ title, back = true, right, subtitle }) {
  const navigate = useNavigate();
  return (
    <header className="flex items-center gap-3 px-5 pt-6 pb-4">
      {back && (
        <button onClick={() => navigate(-1)} className="ga-surface flex h-10 w-10 items-center justify-center rounded-full transition-transform active:scale-95" aria-label="Voltar" data-testid="page-back-button">
          <ArrowLeft size={20} />
        </button>
      )}
      <div className="min-w-0 flex-1">
        <h1 className="truncate text-xl font-semibold tracking-tight" data-testid="page-title">{title}</h1>
        {subtitle && <p className="ga-muted text-xs">{subtitle}</p>}
      </div>
      {right}
    </header>
  );
}
